import { tagCloud, topics } from "@/mocks/home";

export default function TopicShell() {
  return (
    <section id="topics" className="bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div>
            <p className="text-xs font-bold tracking-[0.22em] text-primary-600">SECTIONS · 栏目导航</p>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
              按现场分区，按坑位围观
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              每个分区一个档案柜，收录最想让人重看的翻车瞬间，随开随看。
            </p>
          </div>
          <span className="hidden md:flex items-center gap-1.5 rounded-full bg-background-100 text-foreground-500 px-4 py-2 text-xs font-medium whitespace-nowrap">
            <i className="ri-database-2-line" />
            已收录 8,851 段现场记录
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-5">
          {topics.map((t) => (
            <a
              href="#archive"
              key={t.title}
              className="group card-lift relative flex aspect-[16/11] overflow-hidden rounded-xl bg-background-100"
            >
              <img
                src={t.cover}
                alt={`${t.title}，51大雷栏目专区`}
                className="group-img absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/20 to-transparent" />
              <div className="relative mt-auto flex w-full flex-col p-4 md:p-5">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                  <i className={`${t.icon} text-lg`} />
                </span>
                <h3 className="mt-3 font-heading text-lg md:text-xl font-bold text-background-50">{t.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-background-50/80">{t.desc}</p>
                <div className="mt-3 flex items-center justify-between text-xs">
                  <span className="rounded-full bg-background-50/15 px-2.5 py-1 font-medium text-background-50 backdrop-blur-sm whitespace-nowrap">
                    {t.count}
                  </span>
                  <span className="flex items-center gap-1 font-semibold text-accent-300 whitespace-nowrap">
                    进入档案
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2.5">
          <span className="text-xs font-semibold text-foreground-500 whitespace-nowrap">热门坑位标签</span>
          <span className="hidden h-4 w-px bg-background-300 sm:block" />
          {tagCloud.map((t) => (
            <a
              key={t}
              href="#archive"
              className="rounded-full bg-background-100 text-foreground-600 px-3 py-1.5 text-xs font-medium whitespace-nowrap hover:bg-secondary-100 hover:text-secondary-900"
            >
              # {t}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}